import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Search from '../search/Search.jsx';
import SelectionList from '../selection-list/SelectionList.jsx';

import './Autocomplete.scss';

const Autocomplete = ({ canViewHierarchySelector = true, searchTerm, dataList, onChange, onKeyUp, handleSelect, extraClass, placeholder, title, visible, selectedTerm, noBorder, selectedItems, pressEnterToSearch }) => {
  const autocompleteClass = classnames(noBorder ? 'autocomplete_noborder' : 'autocomplete', {
    [extraClass]: extraClass,
  });

  return (
    <div className={autocompleteClass}>
      { title !== '' &&
        <div className="autocomplete__title">
          { title }
        </div>
      }
      {(canViewHierarchySelector || visible) &&
        <Search
        filterText={searchTerm}
        onChange={onChange}
        onKeyUp={onKeyUp}
        placeholder={placeholder}
        minLength={pressEnterToSearch ? 10000 : 1}
        pressEnterToSearch={pressEnterToSearch}
      />}
      <SelectionList
        dataList={dataList}
        handleSelect={handleSelect}
        visible={visible}
        searchTerm={searchTerm}
        selectedTerm={selectedTerm}
        selectedItems={selectedItems}
      />
    </div>
  );
};

Autocomplete.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  dataList: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  handleSelect: PropTypes.func.isRequired,
  extraClass: PropTypes.string,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  visible: PropTypes.bool,
  selectedItems: PropTypes.array,
  pressEnterToSearch: PropTypes.bool,
};

Autocomplete.defaultProps = {
  title: '',
  extraClass: '',
  placeholder: '',
  searchTerm: '',
  onKeyUp: () => {},
  selectedItems: [],
  pressEnterToSearch: false,
};

export default Autocomplete;
